export const environment = {
    environment: 'DEV',
    production: true,
    locale: 'hu',
    log: null,
};
  